import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { CNC_ENQUIRY, CALL_URL } from "@/data/company";

export const CncPatterns = () => (
  <section id="cnc-patterns" className="bg-stone border-y border-bone/10 px-6 md:px-12 lg:px-20 py-24 md:py-32" data-testid="cnc-section">
    <Reveal><Chapter index="04" title="CNC Carved Patterns" testid="cnc-chapter" /></Reveal>
    <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 mt-10">
      <Reveal className="lg:col-span-7">
        <h2 className="font-heading font-bold text-4xl sm:text-5xl leading-[1.1]" data-testid="cnc-heading">
          A different dimension<br className="hidden sm:block" /> <span className="font-editorial italic text-copper font-medium">to natural stone.</span>
        </h2>
        <p className="text-bone/65 text-sm md:text-base leading-relaxed max-w-xl mt-7" data-testid="cnc-description">
          CNC carved patterns are part of our catalog offering. Speak with our team about designs, stone options and dimensions for your project.
        </p>
        <div className="flex flex-wrap gap-x-7 gap-y-5 mt-9">
          <a href={CNC_ENQUIRY} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 text-sm font-heading text-copper border-b border-copper/50 pb-2 transition-colors hover:text-bone" data-testid="cnc-whatsapp-button"><MessageCircle size={18} /> Request CNC designs <ArrowUpRight size={16} /></a>
          <a href={CALL_URL} className="text-sm font-heading text-bone/75 border-b border-bone/30 pb-2 transition-colors hover:text-copper" data-testid="cnc-call-button">Discuss your project</a>
        </div>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5">
        <dl className="border-t border-bone/20" data-testid="cnc-details">
          {[
            ["01", "Designs & carved samples", "Request the current selection"],
            ["02", "Stone, panel size & depth", "Confirmed for your project"],
            ["03", "Pricing & lead time", "Quoted against your requirements"],
          ].map(([n, name, text]) => (
            <div key={n} className="flex gap-5 py-5 border-b border-bone/15" data-testid={`cnc-detail-${n}`}>
              <span className="font-editorial italic text-copper">{n}</span>
              <div><dt className="font-heading text-base">{name}</dt><dd className="text-sm text-bone/50 mt-1">{text}</dd></div>
            </div>
          ))}
        </dl>
      </Reveal>
    </div>
  </section>
);